import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Partials from '../partials';

const propTypes = {
    title: PropTypes.string,
    blocks: PropTypes.array,
    categories: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string,
    })),
};

const defaultProps = {
    title: 'Books',
    blocks: [],
    categories: [
        {
            value: 'web',
            label: 'Web',
            col: 0,
        },
        {
            value: 'books',
            label: 'Books',
            col: 0,
        },
        {
            value: 'people',
            label: 'People',
            col: 1,
        },
        {
            value: 'interesting',
            label: 'Interesting things',
            col: 1,
        },
    ],
};

const ResourcesLayout = ({ title, blocks, categories }) => {
    const blocksByCategories = categories.reduce((blocksMap, category) => {
        const categoryBlocks = blocks.filter(block => (
            block.type === 'resource' && block.category === category.value
        ));
        if (categoryBlocks.length) {
            return {
                ...blocksMap,
                [category.value]: {
                    ...category,
                    blocks: categoryBlocks,
                },
            };
        }
        return blocksMap;
    }, {});
    const categoriesKeys = Object.keys(blocksByCategories);
    const otherBlocks = blocks.filter(block => (
        block.type !== 'resource' || categoriesKeys.indexOf(block.category) === -1
    )).map(block => ({
        ...block,
        rounded: false,
        border: false,
        titleOver: true,
    }));
    const cols = [];
    categoriesKeys.forEach((categoryKey) => {
        const category = blocksByCategories[categoryKey];
        if (typeof cols[category.col] === 'undefined') {
            cols[category.col] = [];
        }
        cols[category.col].push(category);
    });

    const colsClassName = classNames({
        cols: true,
        'cols-half': cols.length < 2,
    });

    return (
        <div className="layout layout-resources layout-with-cols">
            <h1 className="title page-title">{title}</h1>
            <Partials.Block blocks={otherBlocks || []} />
            <div className={colsClassName}>
                { cols.map(colCategories => (
                    <div className="col col-half">
                        <div className="col-inner">
                            { colCategories.map(category => (
                                <div className="resource-section">
                                    <h2 className="section-title">{ category.label }</h2>
                                    <Partials.Block blocks={category.blocks || []} />
                                </div>
                            )) }
                        </div>
                    </div>
                )) }
            </div>
        </div>
    );
};

ResourcesLayout.propTypes = propTypes;
ResourcesLayout.defaultProps = defaultProps;

export default ResourcesLayout;



// WEBPACK FOOTER //
// ./components/layouts/ResourcesLayout.jsx